import { useMemo } from 'react';

import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { FormFieldContainer } from '@bambi/component-library/src/components/forms/layout/FormFieldContainer';
import { keyBy, without } from 'lodash-es';

import { daysOfTheWeek } from 'src/common/primitives/DayButton/constants';
import DayButton from 'src/common/primitives/DayButton/DayButton';

import { FormFieldProps } from '../../FormField';

type CoreDaySelectorFormFieldProps = Omit<
  FormFieldProps<string[]>,
  'type' | 'inputProps'
> & {
  inputProps: {
    value?: string[];
    onChange?: (updated: string[]) => void;
  };
};
export default function CoreDaySelectorFormField({
  colSpan,
  inputProps,
  label,
  error,
  helperText,
  className,
  inline,
}: CoreDaySelectorFormFieldProps) {
  const selectedDays = useMemo(() => {
    if (!inputProps.value) {
      return {};
    }
    return keyBy(inputProps.value, (d) => d.toLowerCase());
  }, [inputProps.value]);

  return (
    <FormFieldContainer colSpan={colSpan}>
      <DefaultFormFieldLayout
        label={label}
        error={error}
        inputId="day-selector"
        className={className}
        inline={inline}
        helperText={helperText}
      >
        <div className="relative flex items-center">
          <div className="flex gap-x-2">
            {daysOfTheWeek.map((day) => (
              <DayButton
                key={day}
                day={day}
                selected={!!selectedDays[day.toLocaleLowerCase()]}
                onClick={() => {
                  if (selectedDays[day.toLocaleLowerCase()]) {
                    return inputProps.onChange?.(
                      without(inputProps.value, day)
                    );
                  }
                  return inputProps.onChange?.([
                    ...(inputProps.value ?? []),
                    day,
                  ]);
                }}
              />
            ))}
          </div>
        </div>
      </DefaultFormFieldLayout>
    </FormFieldContainer>
  );
}
